import { dataPlay } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPlay = /*#__PURE__*/createIcon(dataPlay)
export default IconPlay
